module.exports = __webpack_public_path__ + "img/google-play-badge_ko_equalised.5a97dbbc.svg";